/* ─── Worn Desires — theme.js ─── */

/* Nav scroll */
const mainNav = document.getElementById('mainNav');
if (mainNav) {
  window.addEventListener('scroll', () => {
    mainNav.classList.toggle('scrolled', window.scrollY > 60);
  });
}

/* ─── Countdown ─── */
function initCountdown() {
  const el = document.getElementById('wdCountdown');
  if (!el) return;
  const raw = el.dataset.date;
  if (!raw) return;
  const target = new Date(raw.includes('Z') ? raw : raw + 'Z');
  function tick() {
    const diff = target - new Date();
    if (diff <= 0) {
      ['days','hours','minutes','seconds'].forEach(id => {
        const node = document.getElementById(id);
        if (node) node.textContent = '00';
      });
      return;
    }
    const d = Math.floor(diff / 86400000);
    const h = Math.floor((diff % 86400000) / 3600000);
    const m = Math.floor((diff % 3600000) / 60000);
    const s = Math.floor((diff % 60000) / 1000);
    const set = (id, val) => {
      const node = document.getElementById(id);
      if (node) node.textContent = String(val).padStart(2, '0');
    };
    set('days', d); set('hours', h); set('minutes', m); set('seconds', s);
  }
  tick();
  setInterval(tick, 1000);
}
initCountdown();

/* ─── Reveal on scroll ─── */
const revealEls = document.querySelectorAll('.reveal');
if (revealEls.length) {
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); }
    });
  }, { threshold: 0.08 });
  revealEls.forEach(el => io.observe(el));
}

/* ─── Toast ─── */
function showToast(msg) {
  const t = document.getElementById('toast');
  if (!t) return;
  t.textContent = msg;
  t.classList.add('show');
  setTimeout(() => t.classList.remove('show'), 2400);
}

/* ─── Cart Drawer ─── */
const cartDrawer  = document.getElementById('cartDrawer');
const cartOverlay = document.getElementById('cartOverlay');
const cartBody    = document.getElementById('cartBody');
const cartFoot    = document.getElementById('cartFoot');
const cartTotal   = document.getElementById('cartTotal');
const bagDot      = document.getElementById('bagDot');

function openCart() {
  if (cartDrawer)  cartDrawer.classList.add('open');
  if (cartOverlay) cartOverlay.classList.add('open');
}
function closeCart() {
  if (cartDrawer)  cartDrawer.classList.remove('open');
  if (cartOverlay) cartOverlay.classList.remove('open');
}

document.getElementById('navBag')?.addEventListener('click', openCart);
document.getElementById('cartClose')?.addEventListener('click', closeCart);
document.getElementById('cartOverlay')?.addEventListener('click', closeCart);

/* ─── Fetch Shopify Cart & Render ─── */
async function refreshCart() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    renderCartDrawer(cart);
  } catch(e) {
    console.error('Cart refresh error', e);
  }
}

function renderCartDrawer(cart) {
  if (!cartBody) return;
  if (!cart.items || cart.items.length === 0) {
    cartBody.innerHTML = `
      <div class="cart-empty-state">
        <div class="cart-empty-mark">∅</div>
        <div class="cart-empty-msg">Your bag is empty</div>
      </div>`;
    if (cartFoot) cartFoot.style.display = 'none';
    if (bagDot)   bagDot.style.display = 'none';
    return;
  }

  let html = '';
  cart.items.forEach(item => {
    const imgSrc = item.image
      ? item.image.replace(/(\.\w+)$/, '_100x130$1')
      : null;
    const imgHtml = imgSrc
      ? `<img src="${imgSrc}" alt="${item.title}" loading="lazy">`
      : '';
    html += `
      <div class="cart-item">
        <div class="cart-item-img">${imgHtml}</div>
        <div class="cart-item-detail">
          <div class="cart-item-n">${item.product_title}</div>
          <div class="cart-item-s">${item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : ''}</div>
          <div class="cart-item-p">${formatMoney(item.final_line_price)}</div>
        </div>
      </div>`;
  });

  cartBody.innerHTML = html;
  if (cartFoot) cartFoot.style.display = 'block';
  if (cartTotal) cartTotal.textContent = formatMoney(cart.total_price);
  if (bagDot)   bagDot.style.display = 'block';
}

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

/* ─── Add to Cart (collection grid) ─── */
async function addToCartById(variantId, btn) {
  if (!variantId) return;
  const original = btn ? btn.textContent : '';
  if (btn) btn.textContent = '...';

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
    });
    if (!res.ok) throw new Error('Add to cart failed');
    await refreshCart();
    openCart();
    showToast('Added to bag');
  } catch(e) {
    showToast('Could not add item');
    console.error(e);
  } finally {
    if (btn) btn.textContent = original;
  }
}

/* Delegate clicks on .btn-add buttons in the product grid */
document.addEventListener('click', e => {
  const btn = e.target.closest('.btn-add');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();
  const variantId = btn.closest('[data-variant-id]')?.dataset.variantId
                 || btn.dataset.variantId;
  addToCartById(variantId, btn);
});

/* ─── Product Page: variant selector + add to cart ─── */
function initProductPage() {
  const addBtn = document.getElementById('addToCartBtn');
  if (!addBtn) return;

  /* Variant switcher */
  document.querySelectorAll('.variant-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const vid  = btn.dataset.variantId;
      const price = btn.dataset.price;
      addBtn.dataset.variantId = vid;
      addBtn.disabled = btn.disabled;
      const priceEl = document.getElementById('productPrice');
      if (priceEl && price) priceEl.textContent = formatMoney(parseInt(price));
    });
  });

  /* Add to cart */
  addBtn.addEventListener('click', async () => {
    const variantId = addBtn.dataset.variantId;
    if (!variantId) return;
    addBtn.textContent = 'Adding...';
    addBtn.disabled = true;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      });
      if (!res.ok) throw new Error();
      await refreshCart();
      openCart();
      showToast('Added to bag');
    } catch(e) {
      showToast('Could not add item');
    } finally {
      addBtn.textContent = 'Add to Bag';
      addBtn.disabled = false;
    }
  });
}
initProductPage();

/* ─── Cart Page: qty update & remove ─── */
async function updateCartItem(key, quantity) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity })
  });
  window.location.reload();
}

document.addEventListener('click', e => {
  const btn = e.target.closest('[data-cart-action]');
  if (!btn) return;
  const action  = btn.dataset.cartAction;
  const key     = btn.dataset.key;
  const current = parseInt(btn.dataset.current || '0');
  if (action === 'increase') updateCartItem(key, current + 1);
  if (action === 'decrease') updateCartItem(key, Math.max(0, current - 1));
  if (action === 'remove')   updateCartItem(key, 0);
});

/* Initialise cart count on every page load */
refreshCart();
